// extracted by mini-css-extract-plugin
export var item = "RuledList-module--item--WnQng";
export var list = "RuledList-module--list--2B+-G";
export var noRule = "RuledList-module--noRule--x4hLR";
export var ruleBottom = "RuledList-module--ruleBottom--dXU98";
export var ruleTop = "RuledList-module--ruleTop--nGv4L";